import type {Resource} from '@igp/shared/access-control';
import {defineAccessControlledResource, PoliciesAccessRule, Policy} from '@igp/shared/access-control';

/**
 * @deprecated Resources should not be shared. Import Policy or PolicyRule instead and create resource where it is used
 */
export const agentResources: Resource = defineAccessControlledResource({
    name: 'policyResources_agent',
    rules: new PoliciesAccessRule([new Policy('agent')]),
});

export const agentPolicy = new Policy('agent');

export const agentPolicyRule = new PoliciesAccessRule([agentPolicy]);

export const adminPolicyRule = new PoliciesAccessRule([new Policy('admin')]);
